/** @format */

import axios from "axios";
// import alertify from "alertifyjs";
import { getAlert } from "../../util/alert";
import Constantes from "../../util/Constantes";

const SERVER = process.env.REACT_APP_SERVER_URL_UPNCORE;
const PATH_LOCATION = Constantes().ApiConfig.PATH_Attendance;
const ENDPOINT = `${SERVER}${PATH_LOCATION}`;
const headers = Constantes().ApiConfig.headers;
const dataUser = JSON.parse(localStorage.getItem("userLogin"));
const API = {
  listar: async (Obj, alertMessage) => {
    try {
      let result = await axios.get(
        `${ENDPOINT}${Obj.codigo}/${Obj.courseId}/${Obj.courseSection}/${Obj.period}`,
        { headers: headers }
      );
      if (dataUser == undefined) {
        getAlert(Constantes().msmAsistencias, Constantes().login, alertMessage);
      } else if (result.data.Status == "NOK") {
        getAlert(result.data.message, "", alertMessage);
      } else if (result.data.detail.sessionArray.length == 0) {
        getAlert(Constantes().msmAsistencias, "", alertMessage);
      }
      return await result.data.detail;
    } catch (err) {
      getAlert(
        Constantes().SeccionExpirada,
        process.env.REACT_APP_SERVER_URL_UPNHOSTBASE
      );
    }
    // return await (await axios.get(`${ENDPOINT}${id}`, { headers: headers })).data.detail;
  },
};

export default API;
